import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import Spinner from '../../components/Spinner';
import Verify from '../../components/join/Verify';
import { resetVerify, setIsVerify } from '../../store/verify.slice';
import { ACCOUNT_STATUS_TYPE } from './login';
import { isFinalStep } from '../../store/find.slice';


interface IProps {
  inputIdRef: any;
  setLoginCertificationVisible: any;
  onSetFindModal: any;
}

export enum FindContent {
  Verify,
  FindIdList
}

const FindId: FC<IProps> = ({
  inputIdRef,
  setLoginCertificationVisible,
  onSetFindModal
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state: RootState) => state.find);
  const [idList, setIdList] = useState<any[] | any>([]);
  const [content, setContent] = useState(FindContent.Verify);

  const [isFindIdList, setIsFindIdList] = useState(false);



  useEffect(()=> {
    setContent(FindContent.Verify);
    return () => {
      setContent(FindContent.Verify);
      dispatch(isFinalStep(false));
    };
  }, []);

  useEffect(()=> {
    setIdList(data);
    dispatch(resetVerify());
  }, [isFindIdList]);


    
  const goPageFindIdList = () => {
    dispatch(setIsVerify(false));
    setIsFindIdList(true);
    setContent(FindContent.FindIdList);
  }

  const onGoLogin = () => {
    setLoginCertificationVisible(false);
    inputIdRef.current.focus();
  }

  const renderTabContent = () => {
    switch (content) {
      
      case FindContent.Verify:
        return (
          <Verify
            verifyType={ACCOUNT_STATUS_TYPE.FIND_ID}
            handleNextPage={goPageFindIdList}
          />
        );

      case FindContent.FindIdList:
          return (
            (isFindIdList && idList.length > 0) && (
              <>

                <div className="result-area">
                  <ul>
                    {idList?.map((member: any) => <li key={member}>{member.webID}</li>)}
                  </ul>
                </div>
                <div className="btn-area">
                  <button type="button"
                          className="btn-basic pink"
                          onClick={onGoLogin}
                  >
                    {t('auth.findId.button3')}
                  </button>
                  <button type="button" className="btn-basic"
                          onClick={() => onSetFindModal(ACCOUNT_STATUS_TYPE.FIND_PASSWORD)}
                  >
                    {t('auth.findId.button4')}
                  </button>
                </div>
              </>
            )
          )
    }
  }

  return (
    <>
      {renderTabContent()}
    </>
  )
}

export default FindId;
